import {Stack, StackProps} from '../Stack/Stack';

export interface CenterProps extends Omit<StackProps, 'direction' | 'align' | 'justify'> {}

/**
 * Center component - centers children both horizontally and vertically
 * Extends Stack with locked alignment props for centering behavior.
 *
 * @example
 * <Center>
 *   <div>Centered content</div>
 * </Center>
 * // With sizing:
 * <Center width={8} height={8}>
 *   <Icon />
 * </Center>
 * // With spacing and test ID:
 * <Center spacing={4} data-testid="my-center">
 *   <Text>Content</Text>
 * </Center>
 */
export function Center(props: CenterProps) {
  return <Stack align="center" justify="center" direction="row" {...props} />;
}
